<button class="swap-button" i18n-title title="Swap Locations" (click)="onSwap()">
  <fa-icon [icon]="faRightLeft" attr.aria-label="Swap Locations"></fa-icon>
  <span class="swap-text" i18n="@@SwapLocations">Swap locations</span>
</button>
